import React from "react";
import styles from "./About.module.css";
import { frontend, mobile, fullstack } from "../../assets";
import { motion } from "framer-motion";

const About = () => {
  return (
    <section id="about" className={styles.container}>
      <div className={styles.top}>
        <motion.div
          className={styles.about}
          initial={{
            x: -850,
          }}
          animate={{
            x: 2,
          }}
          transition={{
            delay: 0.6,
            type: "spring",
            duration: 3,
          }}
        >
          <h1>About Me</h1>
          <p>
            Hi there! I have worked as a Fullstack Engineer and Trainer for
            different companies and also as a Freelancer. 200+ Successful
            Clients from 30 different countries and trained 12k+ students.
          </p>
          <button>
            <a
              target="_blank"
              href="https://drive.google.com/file/d/1Ccmxe8CG9nm2IjdXIxUXhL7p1tElgif_/view?usp=sharing"
              rel="noreferrer"
            >
              Download CV
            </a>
          </button>
        </motion.div>
        <div className={styles.about__card}>
          <img src={frontend} alt="frontend" />
          <h3>Front End Developer</h3>
          <p>
            Frontend Developer with proven ability to adapt to new technologies
            and collaborate effectively with other developers and mentor them at
            the same time.
          </p>
          <button>Learn More</button>
        </div>
      </div>
      <div className={styles.bottom}>
        <div className={`${styles.about__card} ${styles.bottom__card3}`}>
          <img src={frontend} alt="frontend" />
          <h3>Front End Developer</h3>
          <p>
            Frontend Developer with proven ability to adapt to new technologies
            and collaborate effectively with other developers and mentor them at
            the same time.
          </p>
          <button>Learn More</button>
        </div>
        <div className={`${styles.about__card} ${styles.bottom__card1}`}>
          <img src={fullstack} alt="fullstack" />
          <h3>Fullstack Developer</h3>
          <p>
            Fullstack Developer who is passionate about going the extra mile to
            ensure the customer is unquestionably satisfied with the product or
            service provided.
          </p>
          <button>Learn More</button>
        </div>
        <div className={`${styles.about__card} ${styles.bottom__card2}`}>
          <img src={mobile} alt="mobile" />
          <h3>App Developer</h3>
          <p>
            App Developer with experience in both React Native and Flutter.
            Worked on 10+ React Native application including offline storage and
            one of the app got more than 2000+ downloads in playstore.
          </p>
          <button>Learn More</button>
        </div>
      </div>
    </section>
  );
};

export default About;
